import { PageRef } from 'providers/page-ref';

export type AdminEditExerciseSlotPageParams = {
  id?: string;
};

export const IAdminEditExerciseSlotPage: PageRef<AdminEditExerciseSlotPageParams, void> = {
  pageName: 'AdminEditExerciseSlotPage',
} as PageRef<AdminEditExerciseSlotPageParams, void>;
